import { PaginatedResponse } from '@/calendesk/models/DTO/Response/Interface/PaginatedResponse'
import { Expose, Type } from 'class-transformer'
import SimpleStoreProductTransaction from '@/calendesk/models/DTO/Response/SimpleStoreProductTransaction'

export default class SimpleStoreProductTransactionResponse extends PaginatedResponse {
  @Expose()
  @Type(() => SimpleStoreProductTransaction)
  public data!: Array<SimpleStoreProductTransaction>
}
